export default __webpack_public_path__ + "static/media/project-sunnyside.4f060d94.PNG";